import $ from 'jquery';
import 'mapbox.js/dist/mapbox.js';
import 'mapbox.js/dist/mapbox.css';
import { mapbox_key, mapbox_style, theme_url } from '../utils/config';

let $map, $mapContainer, map, popup, pointsLayer;
let mapPointsData;

/* ---------------------------
   Debug toggle via ?debugPins=1
---------------------------- */
const DEBUG = /(?:\?|&)debugPins=1(?:&|$)/i.test(window.location.search);
function describeEl(el) {
  if (!el) return '(null)';
  const id = el.id ? `#${el.id}` : '';
  const cls = el.className ? `.${String(el.className).split(/\s+/).join('.')}` : '';
  return `<${el.tagName.toLowerCase()}${id}${cls}>`;
}
function dbg(tag, extra = {}) {
  if (!DEBUG) return;
  const y = window.pageYOffset;
  const z = map ? map.getZoom() : '(no-map)';
  const c = map ? map.getCenter() : null;
  const center = c ? `${c.lat.toFixed(6)},${c.lng.toFixed(6)}` : '(n/a)';
  const ael = document.activeElement ? describeEl(document.activeElement) : '(no-active-el)';
  const hash = window.location.hash || '(no-hash)';
  // eslint-disable-next-line no-console
  console.log(tag, { pageYOffset: y, zoom: z, center, hash, activeEl: ael, ...extra });
}

function setMapSize() {
  if (!map) return;
  const headerOffset = (window._ILSFA_getHeaderOffset && window._ILSFA_getHeaderOffset()) || 0;
  const jumpToOffset = (window._ILSFA_getJumpToOffset && window._ILSFA_getJumpToOffset()) || 0;

  if (!$('body').hasClass('vendor-directory')) {
    $mapContainer.height($(window).height() - headerOffset - jumpToOffset);
  } else {
    $mapContainer.height($(window).height() - headerOffset);
  }

  try { map.invalidateSize(); } catch (e) {}

  if ($mapContainer.hasClass('stuck')) {
    $mapContainer.css('top', (!$('body').hasClass('vendor-directory')) ? (headerOffset + jumpToOffset) : headerOffset);
  } else {
    $mapContainer.css('top', '');
  }
}

function flyTo(latLng, title) {
  if ($('body').hasClass('vendor-directory')) return;
  if (!map) return;
  dbg('[Leaflet][PIN] flyTo() → start', { latLng, title });
  map.flyTo(L.latLng(latLng[1], latLng[0]), 14);
  popup.setLatLng([latLng[1], latLng[0]]).setContent(title).openOn(map);
  dbg('[Leaflet][PIN] flyTo() → end', { latLng, title });
}

function mapPointClick(id, e) {
  dbg('[Leaflet][PIN] mapPointClick() → enter', {
    featureId: id,
    originalEvent: e && e.originalEvent ? e.originalEvent.type : '(no-e)',
  });

  const $mapCards = document.querySelector('.cards');
  const $mapPoint = $('.map-point[data-id=' + id + ']');
  const $mapPointJS = document.querySelector('.map-point[data-id="' + id + '"]');

  // Reset other points
  $('.map-point').not('[data-id="' + id + '"]').removeClass('active');

  // 👉 Use the JUMPTO anchor as the scroll target on desktop
  dbg('[Leaflet][PIN] ILSFA_scrollBody("#organizations")');
  if ($(window).width() > 700) {
    window.ILSFA_scrollBody 
      ? window.ILSFA_scrollBody('#organizations')
      : $('html,body').animate({ scrollTop: $('#organizations').offset().top }, 300);
  } else {
    window.ILSFA_scrollBody 
      ? window.ILSFA_scrollBody('#map-sticky-parent')
      : $('html,body').animate({ scrollTop: $('#map-sticky-parent').offset().top }, 300);
  }

  // Scroll the cards pane to the clicked/hovered card
  if ($mapCards && $mapPointJS) {
    const pos = getRelativePos($mapPointJS);
    dbg('[Leaflet][PIN] cards pane smoothScroll → start', { targetTop: pos.top - 20 });
    smoothScroll($mapCards, pos.top - 20, 0.5);
    setTimeout(() => dbg('[Leaflet][PIN] cards pane smoothScroll → end'), 520);
  }

  // Hover class
  $('.map-point').removeClass('-hover');
  $mapPoint.addClass('-hover');

  // Toggle details or show popup
  if (!$mapPoint.hasClass('active')) {
    dbg('[Leaflet][PIN] toggler.trigger("click")');
    $mapPoint.find('a.toggler').trigger('click', e);
  } else {
    dbg('[Leaflet][PIN] popup.setLatLng() + .openOn(map)');
    popup.setLatLng([
      parseFloat($mapPoint.attr('data-lat')),
      parseFloat($mapPoint.attr('data-lng')),
    ]).setContent($mapPoint.attr('data-title')).openOn(map);
  }

  dbg('[Leaflet][PIN] mapPointClick() → exit');
}

function getRelativePos(elm) {
  const p = elm.parentNode.getBoundingClientRect();
  const c = elm.getBoundingClientRect();
  return { top: c.top - p.top + elm.parentNode.scrollTop, right: c.right - p.right, bottom: c.bottom - p.bottom, left: c.left - p.left };
}
function easeInOutQuad(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
function smoothScroll(element, to, durationSec) {
  const start = element.scrollTop, change = to - start, startTime = performance.now();
  (function anim() {
    const now = performance.now();
    const elapsed = (now - startTime) / 1000;
    const t = (elapsed / durationSec);
    element.scrollTop = start + change * easeInOutQuad(t);
    if (t < 1) window.requestAnimationFrame(anim);
  }());
}

export function initMapLeaflet() {
  $map = $('#map');
  $mapContainer = $('.map-container');

  if ($('body').hasClass('vendor-directory') && $map.length) $mapContainer.height(500);

  const start = $('body').is('vendor-directory', 'job-training', 'grassroots-education')
    ? { center: [-87.6568088, 41.8909229], zoom: 11.5 }
    : { center: [-89.185000, 40.053333], zoom: 5.5 };

  const z = Math.ceil(start.zoom) + 1;
  const c = [start.center[1], start.center[0]];

  const boundariesCanvas = L.canvas({ padding: 0.5 });

  L.mapbox.accessToken = mapbox_key;

  // Map (keyboard disabled so container won't be focus target)
  map = new L.mapbox.Map('map', null, { zoomControl: false, keyboard: false }).setView(c, z);

  // Force container non-focusable (belt & suspenders)
  try {
    const container = map.getContainer();
    if (container) {
      container.setAttribute('tabindex', '-1');
      container.removeAttribute('aria-label'); // optional
    }
  } catch (e) {}

  // Base layer
  popup = L.popup({ offset: new L.Point(0, -10) });
  L.mapbox.styleLayer(mapbox_style).addTo(map);
  map.scrollWheelZoom.disable();

  // ---- Custom non-focusable zoom control (keeps your CSS hook: leaflet-control-zoom) ----
  const CustomZoomControl = L.Control.extend({
    options: { position: 'topleft' },
    onAdd: function (mapInstance) {
      const container = L.DomUtil.create('div', 'leaflet-control leaflet-control-zoom leaflet-bar custom-zoom-control');

      const zoomIn = L.DomUtil.create('div', 'leaflet-control-zoom-in', container);
      zoomIn.innerHTML = '+';

      const zoomOut = L.DomUtil.create('div', 'leaflet-control-zoom-out', container);
      zoomOut.innerHTML = '–';

      // Prevent the browser from ever scrolling the document
      [zoomIn, zoomOut].forEach(el => {
        el.setAttribute('tabindex', '-1');
        el.style.userSelect = 'none';
        el.style.cursor = 'pointer';
        L.DomEvent.disableClickPropagation(el);
        L.DomEvent.disableScrollPropagation(el);
        L.DomEvent.on(el, 'mousedown', ev => { ev.preventDefault(); });
        L.DomEvent.on(el, 'click', ev => {
          ev.preventDefault();
          if ($(window).width() > 700) {
            window.ILSFA_scrollBody 
              ? window.ILSFA_scrollBody('#organizations')
              : $('html,body').animate({ scrollTop: $('#organizations').offset().top }, 300);
          } else {
            window.ILSFA_scrollBody 
              ? window.ILSFA_scrollBody('#map-sticky-parent')
              : $('html,body').animate({ scrollTop: $('#map-sticky-parent').offset().top }, 300);
          }
          if (el === zoomIn) mapInstance.zoomIn();
          else mapInstance.zoomOut();
        });
      });

      return container;
    }
  });
  map.addControl(new CustomZoomControl());

  // Hooks for other modules
  window._ILSFA_setMapSize = setMapSize;
  window._ILSFA_flyTo = flyTo;

  // Debug: map movement/zoom telemetry
  if (DEBUG) {
    map.on('movestart', () => dbg('[Leaflet][MAP] movestart'));
    map.on('move',      () => dbg('[Leaflet][MAP] move'));
    map.on('moveend',   () => dbg('[Leaflet][MAP] moveend'));
    map.on('zoomstart', () => dbg('[Leaflet][MAP] zoomstart'));
    map.on('zoom',      () => dbg('[Leaflet][MAP] zoom'));
    map.on('zoomend',   () => dbg('[Leaflet][MAP] zoomend'));
  }

  setMapSize();

  const $mapPoints = $('.map-point');
  if ($mapPoints.length === 0) return;

  mapPointsData = { type: 'FeatureCollection', features: [] };

  pointsLayer = L.mapbox.featureLayer(null, { id: 'points', type: 'symbol' }).addTo(map);

  // When each marker layer is added, strip keyboard/focusability from the icon
  pointsLayer.on('layeradd', function (e) {
    const marker = e.layer; // L.Marker
    marker.options.keyboard = false;
    marker.setIcon(L.icon(marker.feature.properties.icon));
    marker.unbindPopup();

    // Remove/neutralize tabindex on the DOM icon so click doesn't cause focus scroll
    try {
      const el = marker.getElement ? marker.getElement() : marker._icon;
      if (el) {
        // Kill focusability and scroll-into-view causes
        el.removeAttribute('tabindex');
        el.setAttribute('tabindex', '-1');
        el.removeAttribute('role');
        el.removeAttribute('aria-label');
        el.style.outline = 'none';
        el.style.userSelect = 'none';
        // Keep it clickable
        el.style.pointerEvents = 'auto';
      }
    } catch (err) {}
  });

  // Prevent pre-focus on marker mousedown (this is key to stop “scroll into view”)
  $mapContainer.on('mousedown', '.leaflet-marker-icon', function (e) {
    if (DEBUG) dbg('[Leaflet][PIN] marker mousedown', { el: describeEl(this) });
    e.preventDefault(); // stops focus before click
  });

  // Extra visibility: log marker click entry/exit
  pointsLayer.on('click', (e) => {
    const f = e && e.layer && e.layer.feature ? e.layer.feature : null;
    const props = f ? f.properties || {} : {};
    dbg('[Leaflet][PIN] pointsLayer.click → BEFORE mapPointClick()', {
      featureId: props.id || '(no-id)',
      featureTitle: props.title || '(no-title)',
      originalEvent: e && e.originalEvent ? e.originalEvent.type : '(no-e)',
    });
    mapPointClick(props.id, e);
    setTimeout(() => dbg('[Leaflet][PIN] pointsLayer.click → AFTER mapPointClick()'), 0);
  });

  // Build markers from DOM
  $mapPoints.each(function () {
    const $t = $(this).addClass('mapped');
    if ($t.attr('data-lat')) {
      mapPointsData.features.push({
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [parseFloat($t.attr('data-lng')), parseFloat($t.attr('data-lat'))] },
        properties: {
          'marker-color': '#000000',
          title: $t.attr('data-title'),
          url: $t.attr('data-url'),
          id: $t.attr('data-id'),
          icon: { iconUrl: theme_url + '/resources/images/marker-image.png', iconSize: [36,48], iconAnchor: [18,24] }
        }
      });
    } else {
      $t.addClass('no-coords');
    }
  });

  pointsLayer.setGeoJSON(mapPointsData.features);
  setMapSize();

  // ---- Match GL's "where to look" logic ----
  const stateBounds = L.latLngBounds(
    L.latLng(42.2531464, -89.2081458), // [lat, lng]
    L.latLng(37.0296995, -89.2529057)
  );

  try {
    if ($('body').hasClass('vendor-directory')) {
      // Lock to start center/zoom and prevent zooming in beyond that level (GL parity)
      map.setView(L.latLng(c[0], c[1]), z);
      map.setMaxZoom(z);
      // If you also want to prevent zooming out below z, uncomment:
      // map.setMinZoom(z);
    } else if ($('body').hasClass('job-training')) {
      // Center near IL and fit to the state bounds for a consistent framing (GL parity)
      map.setView(L.latLng(c[0], c[1]), z);
      map.fitBounds(stateBounds, { padding: [100, 100] });
    } else if ($('body').hasClass('grassroots-education')) {
      // Center near IL and fit to the state bounds for a consistent framing (GL parity)
      map.setView(L.latLng(c[0], c[1]), z);
      map.fitBounds(stateBounds, { padding: [100, 100] });
    } else {
      // For everything else: fit to the actual points with some padding
      const features = mapPointsData.features || [];
      if (features.length > 1) {
        const bounds = L.latLngBounds();
        features.forEach(f => bounds.extend([f.geometry.coordinates[1], f.geometry.coordinates[0]])); // [lat,lng]
        map.fitBounds(bounds, { padding: [100, 100] });
      } else if (features.length === 1) {
        map.setView(L.latLng(features[0].geometry.coordinates[1], features[0].geometry.coordinates[0]), z);
      } else {
        // No points? Just use the start center/zoom.
        map.setView(L.latLng(c[0], c[1]), z);
      }
      map.setMinZoom(z);
    }
  } catch (e) {
    // Fallback if anything throws: keep the start center/zoom
    map.setView(L.latLng(c[0], c[1]), z);
  }

  // County boundaries + static labels (Leaflet parity)
  const borderUrl = theme_url + '/app/lib/data/IL_BNDY_County_Py_ILSFA_regions.geojson';
  fetch(borderUrl).then(r => r.json()).then((geo) => {
    // Helper: stamp the SVG attribute on each <path> (Leaflet may re-create paths)
    const applyNonScalingStroke = (layer) => {
      try {
        // L.Path in SVG renderer exposes the DOM path on _path (Leaflet 0.7 / Mapbox.js)
        const path = layer && (layer._path || (layer.getElement && layer.getElement()));
        if (path && path.setAttribute) {
          path.setAttribute('vector-effect', 'non-scaling-stroke');
          // Optional cosmetics
          path.setAttribute('stroke-linejoin', 'round');
          path.setAttribute('stroke-linecap', 'round');
        }
      } catch (e) {}
    };

    // Create a GeoJSON line layer; className lets you style if desire
    const boundariesLayer = L.geoJson(geo, { 
      renderer: boundariesCanvas,
      style: () => ({ color: '#5062e5', weight: 2, className: 'ilsfa-boundary' }) 
    }).addTo(map);

    // Initial stamping + stamp again whenever Leaflet adds layers/paths
    boundariesLayer.eachLayer(applyNonScalingStroke);
    boundariesLayer.on('layeradd', (ev) => applyNonScalingStroke(ev.layer));
    map.on('viewreset', () => boundariesLayer.eachLayer(applyNonScalingStroke));
    map.on('zoomstart', () => boundariesLayer.eachLayer(applyNonScalingStroke));
    map.on('zoom', () => boundariesLayer.eachLayer(applyNonScalingStroke));

    // Interpolate line weight by zoom, and update continuously during animation
    const setWeight = () => {
      try { const zc = map.getZoom(); const w = (zc >= 10 ? 5 : (zc >= 7 ? 3 : 2)); boundariesLayer.setStyle({ weight: w }); } catch (e) {}
    };
    map.on('zoom', setWeight); map.on('zoomend', setWeight); setWeight();

    // County labels as permanent tooltips (unchanged)
    boundariesLayer.eachLayer((layer) => {
      try {
        const center = layer.getBounds().getCenter();
        const name = (layer.feature && layer.feature.properties) ? layer.feature.properties['COUNTY_NAM'] : '';
        if (name) L.marker(center, { opacity: 0, interactive: false })
          .bindTooltip(name, { permanent: true, direction: 'center', className: 'region-label' })
          .addTo(map);
      } catch (e) {}
    });
  }).catch(() => {});

  // Sticky map (same offsets)
  new window.Waypoint.Sticky({
    element: $mapContainer[0],
    wrapper: '<div class="map-sticky-wrapper" />',
    handler: () => setMapSize(),
    offset: () => {
      const headerOffset = (window._ILSFA_getHeaderOffset && window._ILSFA_getHeaderOffset()) || 0;
      const jumpToOffset = (window._ILSFA_getJumpToOffset && window._ILSFA_getJumpToOffset()) || 0;
      return (!$('body').hasClass('vendor-directory')) ? (headerOffset + jumpToOffset) : headerOffset;
    }
  });

  new window.Waypoint({
    element: $('.map-column')[0],
    handler: (direction) => { $mapContainer.toggleClass('stuck-bottom', direction === 'down'); },
    offset: 'bottom-in-view',
  });

  /* =======================================================
     FINAL PIN-CLICK SCROLL GUARDS
     ======================================================= */

  // 1) Disable Leaflet keyboard navigation at runtime (some builds re-enable it)
  try {
    map.keyboard.disable();
    if (map._container) {
      map._container.removeAttribute('tabindex');
      map._container.setAttribute('tabindex', '-1');
    }
  } catch (e) {}

  // 2) For any future added marker via any layeradd, strip focusability again
  map.on('layeradd', (evt) => {
    const layer = evt.layer;
    if (layer instanceof L.Marker) {
      layer.options.keyboard = false;
      try {
        const el = layer.getElement ? layer.getElement() : layer._icon;
        if (el) {
          el.removeAttribute('tabindex');
          el.setAttribute('tabindex', '-1');
          el.removeAttribute('role');
          el.removeAttribute('aria-label');
          el.style.outline = 'none';
          el.style.userSelect = 'none';
        }
      } catch (e) {}
      layer.on('add', () => setTimeout(() => {
        try {
          const el = layer.getElement ? layer.getElement() : layer._icon;
          if (el) {
            el.removeAttribute('tabindex');
            el.setAttribute('tabindex', '-1');
            el.removeAttribute('role');
            el.removeAttribute('aria-label');
            el.style.outline = 'none';
            el.style.userSelect = 'none';
          }
        } catch (e) {}
      }, 0));
    }
  });

  // 3) Global focus interceptor to kill any last “scroll into view”
  document.addEventListener('focusin', (ev) => {
    const el = ev.target;
    if (!el || !el.classList) return;

    // If a Leaflet element gains focus → blur immediately
    if (
      el.classList.contains('leaflet-marker-icon') ||
      el.classList.contains('leaflet-interactive') ||
      el.classList.contains('leaflet-container') ||
      el.classList.contains('leaflet-pane')
    ) {
      if (DEBUG) dbg('[Leaflet][FOCUS] blur leaflet element', { el: describeEl(el) });
      try { el.blur(); } catch (_) {}
      try { document.body.focus({ preventScroll: true }); } catch (_) {}
    }
  }, true);

  // 4) Extra: log marker focus attempts & clicks if debugging
  if (DEBUG) {
    $mapContainer.on('focusin', '.leaflet-marker-icon', function () {
      dbg('[Leaflet][FOCUS] marker focusin', { el: describeEl(this) });
    });
    $mapContainer.on('click', '.leaflet-marker-icon', function () {
      dbg('[Leaflet][PIN] marker <img> click', { el: describeEl(this) });
    });
  }
}
